$(document).ready(function(){
	
	$('.s2_image_slider').slick({
		slidesToShow: 5,
		slidesToScroll: 1,
		autoplay: true,
		arrows: false,
		dots: false,
		variableWidth: true,
		centerMode: true,
		autoplaySpeed: 0,
		speed: 4000,
		cssEase: 'linear',
		responsive: [
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 5,
					slidesToScroll: 1,
				}
			}
		]
	});
});